<template>
  <div class="Autentica" v-loading="loadingPage">
    <span>Autenticação por:</span> <br><br>
    <el-radio @change="editUser" v-model="type_two_factor" label="email">E-mail</el-radio>
    <el-radio @change="editUser" v-model="type_two_factor" label="google2fa">Google Authenticator</el-radio>
    <div style="margin-top: 15px">
      <el-alert
          v-if="type_two_factor === 'email'"
          title="Ao efeturar o login você ira receber um código no seu e-mail."
          type="info"
          :closable="false"
      />
      <QRCode_google v-else/>
    </div>
  </div>
</template>

<script>
import QRCode_google from "@/app/domains/Perfil/components/QRCode_google";
import {mapGetters} from "vuex";
import {putUsers} from "@/app/domains/Records/services";
import {makeErrorFilds} from "@/app/plugins/utils";

export default {
  name: "Autentica",
  components: {
    QRCode_google,
  },
  computed: {
    ...mapGetters('Auth', ['currentUser']),
  },
  watch: {
    'type_two_factor': function (val) {
      
    }
  },
  data() {
    return {
      type_two_factor: '',
      loadingPage: false,
    }
  },
  methods: {
    async editUser () {
      try {
        const response = await putUsers({id: this.currentUser.id, type_two_factor: this.type_two_factor})
        
      } catch (e) {
        this.error = makeErrorFilds(e)
        this.$message({
          showClose: true,
          message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
          type: 'error'
        })
      } finally {
        this.loadingPage = false
      }
    }
  },
  async mounted () {
    this.type_two_factor = this.currentUser.type_two_factor
  }
}
</script>

<style scoped>

</style>
